if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        // Only target the native add-to-cart button.
        // Apps (e.g. Releasit COD) can inject submit buttons too, sometimes with their own attributes.
        this.submitButton =
          this.querySelector('[id^="ProductSubmitButton-"]') ||
          this.querySelector('[type="submit"][name="add"]:not([data-rsi-cod-button])') ||
          this.querySelector('[type="submit"][name="add"]') ||
          this.querySelector('[type="submit"]');

        // Track last clicked submitter for browsers that don't support submitEvent.submitter reliably.
        this.lastClickedSubmitter = null;
        this.form.addEventListener(
          'click',
          (event) => {
            const submitter = event.target.closest('button[type="submit"], input[type="submit"]');
            if (submitter) this.lastClickedSubmitter = submitter;
          },
          true
        );

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        // Only handle the native add-to-cart submit.
        // If the submit came from an app button (e.g. Releasit COD floating "buy now"), do nothing.
        const submitter = evt.submitter || this.lastClickedSubmitter;

        if (submitter) {
          // Ignore app-provided buttons.
          if (submitter.hasAttribute('data-rsi-cod-button')) return;

          // Only intercept when OUR add-to-cart button is the submitter.
          if (this.submitButton && submitter !== this.submitButton) return;
        } else {
          // If we can't reliably detect the submitter (older/mobile browsers), be conservative:
          // only intercept when there's a single submit button and it's our add-to-cart button.
          const submitters = this.form.querySelectorAll('button[type="submit"], input[type="submit"]');
          if (!(this.submitButton && submitters.length === 1 && submitters[0] === this.submitButton)) return;
        }

        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading-overlay__spinner');
            if (spinner) spinner.classList.add('hidden');
            this.lastClickedSubmitter = null;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
